export default {
  master_title: 'Modo marca - Menu',
  title: 'Menu',
  form: {
    has_internal_product_numbers: {
      label: 'Atribuir números de produto',
      tooltip:
        'Atribuir automaticamente números aos produtos com base na sua posição no menu. O número é impresso nos recibos',
    },
  },
  buttons: {
    new_menu: 'Novo menu',
    export_menu: 'Exportar menu',
    refresh: 'Atualizar',
  },
  modals: {
    delete_category: {
      title: 'Eliminar {{name}}',
    },
    delete_products: {
      title: 'Eliminar {{count}} produtos?',
      description: '<strong>{{count}}</strong> serão removidos do menu',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_delete_menu: 'Não foi possível eliminar o menu. Tente novamente',
    menu_got_deleted: 'Menu eliminado',
    failed_to_delete_category: 'Não foi possível eliminar a categoria. Tente novamente',
    category_got_deleted: 'Categoria eliminada',
    failed_to_delete_products: 'Não foi possível eliminar os produtos. Tente novamente',
    product_got_deleted_one: 'Produto eliminado',
    product_got_deleted_other: 'Produtos eliminados',
    failed_to_generate_product_number: 'Ocorreu um erro. Recarregue a página e tente novamente',
    menu_exported: 'Menu exportado',
    failed_to_export_menu: 'Falha ao exportar menu',
  },
};
